import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';

import { ApiQueryParams } from 'types';

import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetPartnerCustomMovementsProps = {
  partnerId: string;
  params?: ApiQueryParams;
  signal?: AbortSignal;
};

export const getPartnerCustomMovements =
  ({ partnerId, params = {}, signal }: GetPartnerCustomMovementsProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get(`/partners/customMovements`, {
        params: {
          partnerId,
          ...params,
        },
        // signal,
      });
      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
